import React from 'react';

/**
 * 사전 조합된 프레임 이미지를 배경으로 사용하는 UI 컴포넌트
 * Python으로 9-slice 조합 완료된 PNG를 그대로 사용
 */

const PRESETS = {
  bannerTitle:       '/assets/frames/banner_title.png',
  bannerMedium:      '/assets/frames/banner_medium.png',
  paperWide:         '/assets/frames/paper_wide.png',
  paperMedium:       '/assets/frames/paper_medium.png',
  paperLarge:        '/assets/frames/paper_large.png',
  blueButton:        '/assets/frames/btn_blue.png',
  blueButtonPressed: '/assets/frames/btn_blue_pressed.png',
  redButton:         '/assets/frames/btn_red.png',
  blueButtonSmall:   '/assets/frames/btn_blue_small.png',
  blueButtonSmallPressed: '/assets/frames/btn_blue_small_pressed.png',
  woodWide:          '/assets/frames/wood_wide.png',
  woodMedium:        '/assets/frames/wood_medium.png',
  specialPaper:      '/assets/frames/special_paper.png',
};

function NineSlice({ preset, children, className = '', style = {}, onClick }) {
  const src = PRESETS[preset];
  if (!src) return <div className={className} style={style}>{children}</div>;

  return (
    <div
      className={`game-frame ${className}`}
      onClick={onClick}
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}${src})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        imageRendering: 'pixelated',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default NineSlice;
